import { useToggle } from '../../../core/hooks/useToggle';
import { useArray } from '../../../core/hooks/useArray';
import { useCallback } from 'react';
import { DevPlanFieldListItem, UpdateFieldAnswerListModalProps } from './models';
import { useDispatch } from 'react-redux';
import { updateFieldAnswerListAction } from './api/updateFieldAnswerListAction';
import { saveFieldAnswerListAction } from './saveFieldAnswerListAction';


export const useUpdateFieldAnswerListModalProps = (
  projectId: number,
  participantId: number,
  languageId: number,
  devItemId: number,
  devActionId: number,
  devFieldId: number,
  devFieldAnswerId: number,
  disableModal: boolean,
): UpdateFieldAnswerListModalProps => {
  const dispatch = useDispatch();

  const [modalVisible, toggleModal] = useToggle();

  const [selectedItemIds, addItemId, removeItemId] = useArray<number>();

  const isSelected = useCallback(
    (item: DevPlanFieldListItem) => selectedItemIds.indexOf(item.compilationCategoryListItemId) >= 0,
    [selectedItemIds],
  );

  const onClickListItemCheckbox = useCallback(
    (item: DevPlanFieldListItem) => {
      selectedItemIds.indexOf(item.compilationCategoryListItemId) >= 0
        ? removeItemId(item.compilationCategoryListItemId)
        : addItemId(item.compilationCategoryListItemId);
    },
    [addItemId, removeItemId, selectedItemIds],
  );

  const onClickConfirmAdd = useCallback(
    () => {
      dispatch(saveFieldAnswerListAction(
        languageId,
        devItemId,
        devActionId,
        selectedItemIds,
      ));

      dispatch(updateFieldAnswerListAction(
        projectId,
        participantId,
        languageId,
        devItemId,
        devActionId,
        devFieldId,
        devFieldAnswerId,
        selectedItemIds,
      ));

      !disableModal && toggleModal();
    },
    [
      devActionId,
      devFieldAnswerId,
      disableModal,
      devFieldId,
      devItemId,
      dispatch,
      languageId,
      participantId,
      projectId,
      selectedItemIds,
      toggleModal,
    ],
  );

  return {
    modalVisible,
    toggleModal,
    isSelected,
    onClickListItemCheckbox,
    onClickConfirmAdd,
  };
};
